// Licence actions shared by the track list rows, the player bar and the track page, so a
// track behaves the same wherever it's licensed from. Each takes the calling component
// (for $store and $router) and the track.
import trackClient from '@/api/tracks.js'
import { logAddPaygCartActionClick, logUseSubscriptionActionClick } from '@/utils/segment.js'
import { SUBSCRIBE_FLOW_SWITCH, goToSubscribe } from '@/utils/subscribeFlow.js'

// Licences are sold for the full mix, so an alternate version adds its full mix instead.
export function addTrackToCart (vm, track) {
  logAddPaygCartActionClick()
  const showLicenseSelection = (trackToLicense) => {
    vm.$store.dispatch('cart/setTrackAddingToCart', trackToLicense)
    vm.$store.dispatch('cart/showLicenseSelectionModal')
  }
  if (track.full_mix) {
    return trackClient.retrieve(track.full_mix)
      .then(response => showLicenseSelection(response.data))
  }
  showLicenseSelection(track)
  return Promise.resolve()
}

// Only an active subscription can download; anyone else (none, lapsed, cancelled) is sent
// to the subscription page to sort it out, or with the subscribe flow on, anyone with no
// current subscription is shown the track and asked to choose a plan.
export function showSubscriptionDownload (vm, track) {
  logUseSubscriptionActionClick()
  if (!vm.$store.getters['auth/isLoggedIn']) {
    vm.$store.dispatch('user/showSignupModal', { reason: 'download', track })
    return
  }
  const currentSubscription = vm.$store.getters['subscriptions/currentSubscription']
  if (currentSubscription && currentSubscription.is_active) {
    vm.$store.dispatch('subscriptions/setTrackToDownload', track)
      .then(() => {
        vm.$store.dispatch('subscriptions/showDownloadModal')
      })
  } else if (vm.$store.getters['waffle/isFeatureEnabled'](SUBSCRIBE_FLOW_SWITCH)) {
    const team = vm.$store.getters['user/currentTeam']
    if (team && team.current_subscription) {
      // Past due: the plan pages can't help, so straight to sorting it out.
      goToSubscribe(vm.$router, team)
    } else {
      vm.$store.dispatch('common/showTrackPrompt', { reason: 'subscribe', track })
    }
  } else {
    vm.$router.push({ name: 'subscription' })
  }
}

// Downloading a preview needs an account.
export function showPreviewDownload (vm, track) {
  if (!vm.$store.getters['auth/isLoggedIn']) {
    vm.$store.dispatch('user/showSignupModal', { reason: 'preview', track })
    return
  }
  vm.$store.dispatch('common/setPreviewDownloadUrl', track.watermarked_mp3_320kbps)
    .then(() => {
      vm.$store.dispatch('common/showPreviewDownloadModal')
    })
}
